/* ============================================================================
   Yuvakart - Need Help Choosing (Kundali edition)
   Styles: assets/yk-quiz.css and assets/yk-quiz-intro.css
   Same filename as the old 335 KB quiz so whatever loads it keeps working.

   FLOW  welcome > purpose > pain point > wearability > material > kundali
         > reading > wardrobe > results

   PRODUCTS come from /collections/<handle>?view=ykindex. Question one maps to
   the seven purpose collections and the Nakshatra lord maps to the nine planet
   collections, so nothing about the catalogue is hardcoded here. Filters relax
   one at a time rather than ever returning an empty result.

   THE KUNDALI IS REAL, WITHIN LIMITS. Rashi and Nakshatra are computed from the
   birth date and time using a lunar longitude series with the Lahiri ayanamsa -
   accurate to about a fifth of a degree, reliable for Rashi and right for
   Nakshatra except in borderline minutes. Lagna is NOT computed: it needs the
   birth place latitude, longitude and local sidereal time. Place is collected
   for the record, and nothing on screen claims a Lagna was calculated.
   ============================================================================ */
(function () {
  'use strict';

  var PURPOSE = [
    { t: 'Health & Vitality',   s: 'Body, energy, healing',        e: '🌿', h: 'health-healing' },
    { t: 'Wealth & Abundance',  s: 'Money, career, growth',        e: '💰', h: 'wealth-prosperity' },
    { t: 'Love & Relationships',s: 'Bond, harmony, soulmate',      e: '❤️', h: 'love-relationships' },
    { t: 'Protection & Peace',  s: 'Negativity, anxiety, stress',  e: '🛡️', h: 'protection' },
    { t: 'Spiritual Growth',    s: 'Meditation, clarity, awakening',e: '🕉️', h: 'spirituality-meditation' },
    { t: 'Confidence & Power',  s: 'Self-worth, leadership',       e: '🔥', h: 'career-success' }
  ];

  var PAIN = {
    0: [['Low energy through the day','Waking up tired, or never quite recovering'],
        ['Recurring health worries','Something that keeps coming back'],
        ['Restless mind, poor sleep','Overthinking at night, never switching off']],
    1: [['Improving my finances','Blocked money flow, instability, or wanting real prosperity'],
        ['Growing my business','Sales have plateaued or customers are not coming'],
        ['Career feels stuck','Passed over, underpaid, or waiting for a break']],
    2: [['Finding the right partner','Love has been elusive, or things feel stuck in relationships'],
        ['Harmony at home','Friction with family, or a house that feels tense'],
        ['Healing after a loss','Moving through grief or a difficult ending']],
    3: [['Clearing negative energy','Feeling drained, paranoid, or like something is off'],
        ['Constant anxiety','Worry that sits in the chest and will not lift'],
        ['Protection for my home','Wanting the space itself to feel safe']],
    4: [['Deepening my sadhana','Practice has become mechanical, not alive'],
        ['Beginning a practice','Wanting to start, unsure where'],
        ['Clarity and focus','Mind scattered, hard to sit still']],
    5: [['Self-worth and confidence','Second-guessing yourself in rooms you belong in'],
        ['Leadership and respect','Wanting to be heard and taken seriously'],
        ['Courage for a big step','A decision that needs nerve']]
  };

  var WEAR = [
    { t: 'Daily driver',      s: 'On me all day, every day',    e: '☀️', k: 'daily' },
    { t: 'Occasionally',      s: 'A few times a week',          e: '🌙', k: 'occasional' },
    { t: 'Festivities & puja',s: 'Special occasions only',      e: '🪔', k: 'puja' },
    { t: 'Sadhana only',      s: 'During meditation or prayer', e: '🕉️', k: 'sadhana' }
  ];

  var MATERIAL = [
    { t: 'Rudraksha',  s: 'The tears of Shiva',           e: '🟫', m: 'rudraksha|mukhi' },
    { t: 'Pyrite',     s: 'Fool’s gold, real power',  e: '✨', m: 'pyrite' },
    { t: 'Karungali',  s: 'Black ebony, Saturn’s gift', e: '🖤', m: 'karungali|ebony' },
    { t: 'Citrine',    s: 'The merchant’s stone',     e: '💛', m: 'citrine' },
    { t: 'Tulsi',      s: 'Vishnu’s sacred herb',     e: '🌿', m: 'tulsi' },
    { t: 'Sandalwood', s: 'Calming, divine fragrance',    e: '🪵', m: 'sandalwood|chandan' }
  ];

  var RASHI = ['Mesha','Vrishabha','Mithuna','Karka','Simha','Kanya','Tula','Vrischika','Dhanu','Makara','Kumbha','Meena'];

  var NAK = ['Ashwini','Bharani','Krittika','Rohini','Mrigashira','Ardra','Punarvasu','Pushya','Ashlesha',
    'Magha','Purva Phalguni','Uttara Phalguni','Hasta','Chitra','Swati','Vishakha','Anuradha','Jyeshtha',
    'Mula','Purva Ashadha','Uttara Ashadha','Shravana','Dhanishta','Shatabhisha','Purva Bhadrapada',
    'Uttara Bhadrapada','Revati'];

  var LORD = [
    ['Ketu','ketu'],['Shukra','venus'],['Surya','sun'],['Chandra','moon'],['Mangal','mangal'],
    ['Rahu','rahu'],['Guru','jupiter'],['Shani','shani'],['Budh','mercury']
  ];

  var WEARMAP = {
    daily:      /bracelet|band|pendant|locket/i,
    occasional: /bracelet|pendant|locket|mala/i,
    puja:       /idol|murti|diya|deepak|yantra|ghanti|bell|lota|shivling|kachua|tortoise|akhand|kapoor|agarbatti/i,
    sadhana:    /mala|japa|rudraksha|sphatik|tulsi|sandalwood|karungali/i
  };

  var IC = {
    intent: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"><circle cx="12" cy="12" r="4"/><path d="M12 2v3M12 19v3M2 12h3M19 12h3M4.9 4.9l2.1 2.1M17 17l2.1 2.1M19.1 4.9L17 7M7 17l-2.1 2.1"/></svg>',
    kundali:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="8" r="3.4"/><path d="M5.5 20c0-3.6 2.9-6 6.5-6s6.5 2.4 6.5 6"/></svg>',
    picks:  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="7" height="7" rx="1.5"/><rect x="14" y="3" width="7" height="7" rx="1.5"/><rect x="3" y="14" width="7" height="7" rx="1.5"/><path d="M17.5 14.5v6M14.5 17.5h6"/></svg>'
  };

  var S = { p: null, pain: null, wear: null, mat: null, k: null, items: [], kitems: [] };
  var ov, root, body, foot, prog, stepno;

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (m) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m];
    });
  }
  function inr(paise) {
    var n = Number(paise) / 100;
    if (!isFinite(n) || n <= 0) return '';
    return '₹' + String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  /* ------------------------------------------------------------- kundali -- */

  function rad(d) { return d * Math.PI / 180; }
  function norm(d) { d = d % 360; return d < 0 ? d + 360 : d; }

  function kundali(dateStr, timeStr) {
    var p = dateStr.split('-');
    var y = +p[0], mo = +p[1], da = +p[2];
    var hm = (timeStr || '12:00').split(':');
    var ut = (+hm[0] || 0) + (+hm[1] || 0) / 60 - 5.5;   /* entered as IST */

    var yy = y, mn = mo;
    if (mn <= 2) { yy -= 1; mn += 12; }
    var A = Math.floor(yy / 100), B = 2 - A + Math.floor(A / 4);
    var jd = Math.floor(365.25 * (yy + 4716)) + Math.floor(30.6001 * (mn + 1))
           + da + B - 1524.5 + ut / 24;

    var d = jd - 2451545.0;
    var L = norm(218.3164477 + 13.17639648 * d);
    var M = rad(norm(134.9633964 + 13.06499295 * d));
    var D = rad(norm(297.8501921 + 12.19074912 * d));
    var Ms = rad(norm(357.5291092 + 0.98560028 * d));

    var lon = L
      + 6.289 * Math.sin(M)
      - 1.274 * Math.sin(2 * D - M)
      + 0.658 * Math.sin(2 * D)
      - 0.186 * Math.sin(Ms)
      - 0.059 * Math.sin(2 * M - 2 * D)
      - 0.057 * Math.sin(M - 2 * D + Ms)
      + 0.053 * Math.sin(M + 2 * D)
      + 0.046 * Math.sin(2 * D - Ms)
      + 0.041 * Math.sin(M - Ms)
      - 0.035 * Math.sin(D)
      - 0.031 * Math.sin(M + Ms);

    var ayan = 23.85 + 0.013972 * (y - 2000);
    var sid = norm(lon - ayan);
    var ri = Math.floor(sid / 30);
    var ni = Math.floor(sid / (360 / 27));
    var lord = LORD[ni % 9];

    return { rashi: RASHI[ri], nak: NAK[ni], lord: lord[0], planet: lord[1] };
  }

  /* --------------------------------------------------------------- shell -- */

  function open() {
    ov.className = 'ykq-ov on';
    document.body.style.overflow = 'hidden';
    intro();
  }
  function close() {
    ov.className = 'ykq-ov';
    document.body.style.overflow = '';
  }

  function paint(n, html, footHtml) {
    root.classList.remove('is-intro');
    prog.style.width = (n / 5 * 100) + '%';
    stepno.textContent = n <= 5 ? 'Step ' + n + ' of 5' : 'Your results';
    body.innerHTML = html;
    foot.innerHTML = footHtml || '';
    body.scrollTop = 0;
  }

  /* ------------------------------------------------------------ welcome -- */

  function intro() {
    root.classList.add('is-intro');
    body.innerHTML =
      '<div class="ykq__intro">'
      + '<button class="ykq__ix" id="ykq-ix" aria-label="Close">×</button>'
      + '<div class="ykq__handle"></div>'
      + '<p class="ykq__om">|| ॐ ||</p>'
      + '<h2 class="ykq__ih">Not sure what’s <em>right for you?</em></h2>'
      + '<p class="ykq__ip">Take a quick one-minute quiz. We’ll recommend the right '
      + 'spiritual products based on your needs, your lifestyle and your Kundali.</p>'
      + '<div class="ykq__steps">'
      +   '<div class="ykq__st"><div class="ykq__sic">' + IC.intent + '</div>'
      +     '<div class="ykq__sl">Your intent</div></div>'
      +   '<div class="ykq__st"><div class="ykq__sic">' + IC.kundali + '</div>'
      +     '<div class="ykq__sl">Kundali match</div></div>'
      +   '<div class="ykq__st"><div class="ykq__sic">' + IC.picks + '</div>'
      +     '<div class="ykq__sl">Your picks</div></div>'
      + '</div>'
      + '<button class="ykq__igo" id="ykq-igo">Find my perfect match</button>'
      + '<p class="ykq__ift"><b>✦</b> 5 simple questions · Free · Mobile verification for Kundali</p>'
      + '</div>';
    foot.innerHTML = '';
    document.getElementById('ykq-igo').onclick = step1;
    document.getElementById('ykq-ix').onclick = close;
  }

  /* ------------------------------------------------------------ helpers -- */

  function opts(list, sel, oneCol) {
    return '<div class="ykq__grid' + (oneCol ? ' ykq__grid--one' : '') + '">'
      + list.map(function (o, i) {
        return '<button class="ykq__opt' + (sel === i ? ' on' : '') + '" type="button" data-i="' + i + '">'
          + '<span class="ykq__rad"><i></i></span>'
          + (o.e ? '<span class="ykq__em">' + o.e + '</span>' : '')
          + '<span class="ykq__tx"><span class="ykq__tt">' + esc(o.t) + '</span>'
          + '<span class="ykq__ts">' + esc(o.s) + '</span></span></button>';
      }).join('') + '</div>';
  }

  function cta(label, on, backFn, skipHtml) {
    return '<button class="ykq__go" id="ykq-go"' + (on ? '' : ' disabled') + '>' + label + ' →</button>'
      + (backFn || skipHtml
        ? '<div class="ykq__row">'
          + (backFn ? '<button class="ykq__back" id="ykq-back">← Go back</button>' : '<span></span>')
          + (skipHtml || '<span></span>') + '</div>'
        : '');
  }

  function wireOpts(onPick) {
    [].slice.call(body.querySelectorAll('.ykq__opt')).forEach(function (el) {
      el.onclick = function () {
        [].slice.call(body.querySelectorAll('.ykq__opt')).forEach(function (x) { x.classList.remove('on'); });
        el.classList.add('on');
        var go = document.getElementById('ykq-go');
        if (go) go.removeAttribute('disabled');
        onPick(+el.getAttribute('data-i'));
      };
    });
  }
  function wireFoot(next, back) {
    var go = document.getElementById('ykq-go');
    if (go) go.onclick = next;
    var b = document.getElementById('ykq-back');
    if (b) b.onclick = back;
  }

  /* --------------------------------------------------------------- steps -- */

  function step1() {
    paint(1,
      '<h2 class="ykq__h">What’s pulling at your <em>mann</em> right now?</h2>'
      + '<p class="ykq__sub">Pick what’s actually on your mind — your honest answer is where the magic begins.</p>'
      + opts(PURPOSE, S.p),
      cta('Continue', S.p !== null, intro));
    wireOpts(function (i) {
      if (S.p !== i) S.pain = null;
      S.p = i;
      S.items = [];
      fetchCol(PURPOSE[i].h).then(function (x) { S.items = x; });
    });
    wireFoot(step2, intro);
  }

  function step2() {
    var list = PAIN[S.p].map(function (r) { return { t: r[0], s: r[1], e: '' }; });
    paint(2,
      '<p class="ykq__eye">Your pain point</p>'
      + '<h2 class="ykq__h">If you could fix one thing <em>today</em>…</h2>'
      + '<p class="ykq__sub">The universe already knows. This shapes your recommendation more than anything else.</p>'
      + opts(list, S.pain, true),
      cta('Continue', S.pain !== null, true));
    wireOpts(function (i) { S.pain = i; });
    wireFoot(step3, step1);
  }

  function step3() {
    paint(3,
      '<p class="ykq__eye">Your wearability</p>'
      + '<h2 class="ykq__h">How do you <em>live</em> with your sacred piece?</h2>'
      + '<p class="ykq__sub">We’ll match the right material, weight and form to how you actually wear things.</p>'
      + '<p class="ykq__flab">How often will you wear it?</p>'
      + opts(WEAR, S.wear),
      cta('Continue', S.wear !== null, true));
    wireOpts(function (i) { S.wear = i; });
    wireFoot(step4, step2);
  }

  function step4() {
    paint(4,
      '<p class="ykq__eye">Your preference</p>'
      + '<h2 class="ykq__h">Is there a <em>stone or bead</em> calling to you?</h2>'
      + '<p class="ykq__sub">Trust your instinct — sometimes the material chooses you. Or let your Kundali decide.</p>'
      + opts(MATERIAL, S.mat),
      cta('Continue', true, true,
        '<button class="ykq__skip" id="ykq-skip">No preference →</button>'));
    wireOpts(function (i) { S.mat = i; });
    wireFoot(step5, step3);
    var sk = document.getElementById('ykq-skip');
    if (sk) sk.onclick = function () { S.mat = null; step5(); };
  }

  function verifiedPhone(){
    return window.YK_OTP && window.YK_OTP.isVerified() || '';
  }
  function requirePhone(next){
    if(verifiedPhone()){ next(); return; }
    if(!window.YK_OTP){ window.alert('Mobile verification is unavailable. Please try again later.'); return; }
    window.YK_OTP.open({onVerified:function(){
      window.YK_OTP.close();
      if(ov && ov.classList.contains('on')) next();
    }});
  }

  function step5() {
    if(!verifiedPhone()){ requirePhone(step5); return; }
    paint(5,
      '<p class="ykq__eye">Your kundali</p>'
      + '<h2 class="ykq__h">Tell us when you entered <em>this world</em></h2>'
      + '<p class="ykq__sub">We calculate your Rashi and Nakshatra from your date and time of birth. '
      + 'Even 30 minutes can change the reading — the more accurate, the better your match.</p>'

      + '<div class="ykq__field"><p class="ykq__flab">Your name</p>'
      + '<input class="ykq__in" id="kq-nm" type="text" autocomplete="name" placeholder="Your name">'
      + '<p class="ykq__err" id="e-nm">Please enter your name</p></div>'

      + '<div class="ykq__field"><p class="ykq__flab">Date of birth</p>'
      + '<input class="ykq__in" id="kq-dob" type="date">'
      + '<p class="ykq__err" id="e-dob">Please add your date of birth</p></div>'

      + '<div class="ykq__field"><p class="ykq__flab">Time of birth</p>'
      + '<input class="ykq__in" id="kq-tob" type="time"></div>'

      + '<div class="ykq__field"><p class="ykq__flab">Place of birth</p>'
      + '<input class="ykq__in" id="kq-pl" type="text" placeholder="e.g. Jaipur, India"></div>'

      + '<div class="ykq__why"><b>Why we ask:</b> your Rashi and Nakshatra come from the date and '
      + 'time. The place is kept on your record so our team can read your chart properly if you '
      + 'ask for a personal recommendation.</div>',
      cta('Reveal my products', true, true,
        '<button class="ykq__skip" id="ykq-skip">Skip &amp; show my products</button>'));

    wireFoot(submit, step4);
    var sk = document.getElementById('ykq-skip');
    if (sk) sk.onclick = function () { S.k = null; results(); };
  }

  function bad(id, eid, isBad) {
    var el = document.getElementById(id);
    if (el) el.className = 'ykq__in' + (isBad ? ' bad' : '');
    var e = document.getElementById(eid);
    if (e) e.className = 'ykq__err' + (isBad ? ' on' : '');
    return !isBad;
  }

  function submit() {
    var nm = (document.getElementById('kq-nm').value || '').trim();
    var ph = verifiedPhone();
    if (!ph) { requirePhone(submit); return; }
    var dob = document.getElementById('kq-dob').value || '';
    var tob = document.getElementById('kq-tob').value || '';
    var pl = (document.getElementById('kq-pl').value || '').trim();

    var ok = true;
    ok = bad('kq-nm', 'e-nm', nm.length < 2) && ok;
    ok = bad('kq-dob', 'e-dob', !dob) && ok;
    if (!ok) return;

    S.k = kundali(dob, tob);
    S.k.name = nm; S.k.phone = ph; S.k.dob = dob; S.k.tob = tob; S.k.place = pl;
    lead();
    reading();
  }

  function lead() {
    var k = S.k || {};
    var d = {
      name: k.name || '', phone: k.phone || '', dob: k.dob || '', tob: k.tob || '',
      place: k.place || '', consent: 'yes', source: 'Need Help Choosing',
      answers: [PURPOSE[S.p].t, PAIN[S.p][S.pain] ? PAIN[S.p][S.pain][0] : '',
        WEAR[S.wear] ? WEAR[S.wear].t : '',
        S.mat !== null ? MATERIAL[S.mat].t : 'No preference'].join(' | '),
      recos: k.rashi ? k.rashi + ' Rashi, ' + k.nak + ' Nakshatra, lord ' + k.lord : '',
      page: location.pathname, at: new Date().toISOString()
    };
    try {
      var all = JSON.parse(localStorage.getItem('yk_leads') || '[]');
      all.push(d); localStorage.setItem('yk_leads', JSON.stringify(all));
    } catch (e) {}
    var url = window.YK_LEAD_ENDPOINT || '';
    if (!url) return;
    var b = Object.keys(d).map(function (x) {
      return encodeURIComponent(x) + '=' + encodeURIComponent(d[x]);
    }).join('&');
    fetch(url, { method: 'POST', mode: 'no-cors',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' },
      body: b }).catch(function () {});
  }

  /* ------------------------------------------------------------- results -- */

  function fetchCol(h) {
    return fetch('/collections/' + h + '?view=ykindex', { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (t) { return JSON.parse(t).items || []; })
      .catch(function () { return []; });
  }

  function loading(h, s) {
    paint(6, '<div class="ykq__load"><div class="ykq__spin"></div>'
      + '<p class="ykq__lh">' + h + '</p><p class="ykq__ls">' + s + '</p></div>', '');
    prog.style.width = '100%';
  }

  function reading() {
    loading('Reading your Kundali…', 'Calculating planetary positions');
    var jobs = [S.items.length ? Promise.resolve(S.items) : fetchCol(PURPOSE[S.p].h)];
    jobs.push(S.k && S.k.planet ? fetchCol(S.k.planet) : Promise.resolve([]));
    setTimeout(function () {
      Promise.all(jobs).then(function (r) {
        S.items = r[0]; S.kitems = r[1];
        loading('Preparing your Energy Wardrobe…', 'Matching products to your chart');
        setTimeout(render, 900);
      });
    }, 1100);
  }

  function results() {
    loading('Preparing your Energy Wardrobe…', 'Matching products to your intentions');
    var j = S.items.length ? Promise.resolve(S.items) : fetchCol(PURPOSE[S.p].h);
    j.then(function (x) { S.items = x; setTimeout(render, 700); });
  }

  function pick() {
    var list = S.items.slice();
    var out = [];

    if (S.k && S.kitems.length) {
      var kp = S.kitems.filter(function (p) { return p.a; })[0];
      if (kp) { kp.__k = 1; out.push(kp); }
    }

    function drop(fn) {
      var f = list.filter(fn);
      return f.length >= 3 ? f : list;
    }
    if (S.mat !== null) {
      var re = new RegExp(MATERIAL[S.mat].m, 'i');
      list = drop(function (p) { return re.test(p.t + ' ' + (p.g || '')); });
    }
    if (S.wear !== null) {
      var wr = WEARMAP[WEAR[S.wear].k];
      list = drop(function (p) { return wr.test(p.t + ' ' + (p.y || '')); });
    }
    list.filter(function (p) { return p.a; }).forEach(function (p) {
      if (out.length < 4 && !out.some(function (o) { return o.h === p.h; })) out.push(p);
    });
    return out.slice(0, 4);
  }

  function render() {
    var picks = pick();
    var k = S.k;
    var title = k ? 'Your ' + PURPOSE[S.p].t + ' Bundle' : 'Curated for your journey';
    var sub = k
      ? esc(k.rashi) + ' Rashi · ' + esc(k.nak) + ' Nakshatra · ruled by ' + esc(k.lord)
      : 'Based on your intentions';

    var cards = picks.map(function (p, i) {
      var was = Number(p.c) > Number(p.p) ? '<s>' + inr(p.c) + '</s>' : '';
      var badge = p.__k
        ? '<span class="ykq__badge ykq__badge--k">Kundali Pick</span>'
        : (i === 1 ? '<span class="ykq__badge ykq__badge--f">Featured</span>' : '');
      return '<div class="ykq__card">' + badge
        + '<a href="/products/' + esc(p.h) + '"><img class="ykq__img" src="' + esc(p.i) + '" alt="" loading="lazy"></a>'
        + '<div class="ykq__cb">'
        + '<a class="ykq__cn" href="/products/' + esc(p.h) + '">' + esc(p.t) + '</a>'
        + '<div class="ykq__cp">' + inr(p.p) + was + '</div>'
        + '<button class="ykq__atc" data-v="' + p.v + '">Add to cart</button>'
        + '</div></div>';
    }).join('');

    paint(6,
      '<div class="ykq__hero"><span class="em">🧿</span>'
      + '<p class="ey">Your energy wardrobe</p><h3>' + esc(title) + '</h3><p>' + sub + '</p></div>'
      + '<p class="ykq__eye">Recommended for you</p>'
      + '<div class="ykq__cards">' + cards + '</div>'
      + '<a class="ykq__all" href="/collections/' + PURPOSE[S.p].h + '">See the full collection</a>',
      '');

    [].slice.call(body.querySelectorAll('.ykq__atc')).forEach(function (b) {
      b.onclick = function () {
        var id = b.getAttribute('data-v');
        if (!id || id === '0') { location.href = '/collections/' + PURPOSE[S.p].h; return; }
        requirePhone(function(){
          if(!b.isConnected || b.disabled) return;
          b.disabled = true; b.textContent = 'Adding…';
          Promise.resolve().then(function(){
            return window.YK_CART_SESSION ? window.YK_CART_SESSION.ready() : Promise.resolve();
          }).then(function(){
            return fetch('/cart/add.js', {
              method: 'POST', credentials: 'same-origin',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
            });
          }).then(function (r) {
            if(!r.ok) throw new Error('Could not add to cart');
            b.textContent = '✓ Added';
            document.dispatchEvent(new CustomEvent('cart:updated'));
          }).catch(function () { b.textContent = 'Try again'; b.disabled = false; });
        });
      };
    });
  }

  /* ---------------------------------------------------------------- boot -- */

  function boot() {
    if (document.getElementById('ykq-ov')) return;

    var tab = document.createElement('button');
    tab.className = 'ykq-tab';
    tab.type = 'button';
    tab.textContent = 'Need Help Choosing?';
    tab.onclick = open;
    document.body.appendChild(tab);

    ov = document.createElement('div');
    ov.className = 'ykq-ov';
    ov.id = 'ykq-ov';
    ov.innerHTML =
      '<div class="ykq"><div class="ykq__top">'
      + '<div class="ykq__bar"><span class="ykq__logo">Yuvakart</span>'
      + '<button class="ykq__x" id="ykq-x" aria-label="Close">×</button></div>'
      + '<div class="ykq__prog"><span id="ykq-prog" style="width:20%"></span></div>'
      + '<p class="ykq__stepno" id="ykq-stepno">Step 1 of 5</p></div>'
      + '<div class="ykq__body" id="ykq-body"></div>'
      + '<div class="ykq__foot" id="ykq-foot"></div></div>';
    document.body.appendChild(ov);

    root = ov.querySelector('.ykq');
    body = document.getElementById('ykq-body');
    foot = document.getElementById('ykq-foot');
    prog = document.getElementById('ykq-prog');
    stepno = document.getElementById('ykq-stepno');

    document.getElementById('ykq-x').onclick = close;
    ov.addEventListener('click', function (e) { if (e.target === ov) close(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && ov.className.indexOf('on') > -1) close();
    });

    window.YK_QUIZ = { open: open, close: close, state: S, kundali: kundali };
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
